export default "__VITE_ASSET__DER$uyf6__"